import React from 'react';
import { ColiWithHistoryPublicDataModelWithAgency } from 'src/types/public/public-data-model.types';
import { TrackingColiInfoHistoryViewerItem } from './TrackingColiInfoHistoryViewerItem';

type Props = {
  testID?: string;
  data: ColiWithHistoryPublicDataModelWithAgency;
};

export const TrackingColiInfoHistoryViewer: React.FC<Props> = ({ data, testID = 'TrackingColiInfoHistoryViewer' }) => {
  const {
    coli: { history },
  } = data;

  // const delivered = history.some((item) => item.status === 'DELIVERED' || item.status === 'DELIVERD_TO_TRANSPORT');
  // const withdrawn = history.some((item) => item.status === 'WITHDRAWN');
  // const dispatched = history.some((item) => item.status === 'DISPATCHED');
  // const onlyDelivery = data.toAgency.onlyDelivery;
  // const isTransportProvider = data.toAgency.isTransportProvider;

  return (
    <div>
      {history.map((item, index) => {
        return (
          <TrackingColiInfoHistoryViewerItem
            key={`colis-history-${index}`}
            history={item}
            topTail={true}
            bottomTail={item.status !== 'DELIVERD_TO_TRANSPORT' && item.status !== 'CANCELLED'}
          />
        );
      })}

      {/* {data.coli.status !== 'CANCELLED' && (
        <>
          {!delivered && !withdrawn && !dispatched && (
            <TrackingColiHistoryTemplate
              status={{ label: 'DISPATCHED' }}
              icon={<TrackingColiInfoTemplateIcon Icon={RouteIcon} theme="round" />}
              topTail
              bottomTail
              disabled
            />
          )}

          {!delivered && !withdrawn && (
            <TrackingColiHistoryTemplate
              status={{ label: isTransportProvider ? 'DELIVERD_TO_TRANSPORT' : 'DELIVERED' }}
              icon={<TrackingColiInfoTemplateIcon Icon={DoneCircleIcon} theme="round" />}
              topTail
              bottomTail
              disabled
            />
          )}

          {!withdrawn && !onlyDelivery && !isTransportProvider && (
            <TrackingColiHistoryTemplate
              status={{ label: 'WITHDRAWN' }}
              icon={<TrackingColiInfoTemplateIcon Icon={ArrowCircleIcon} theme="round" />}
              topTail
              disabled
            />
          )}
        </>
      )} */}
    </div>
  );
};
